import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span
                    style={{
                      color: "white",
                      fontSize: "12px",
                    }}
                  >
                    (Electronic verification of ID powered by Icredit)
                  </span>
                </h1>
                <p
                // style={{
                //   color: "#5ca9fb",
                //   fontWeight: "700",
                //   background: "rgba(255,255,255,0.8)",
                //   padding: "5px",
                //   borderRadius: "1rem",
                // }}
                >
                  {props.data ? props.data.paragraph : "Loading"}
                </p>
                <a
                  target="_blank"
                  rel="noopener"
                  href="https://onboarding.icreditkyc.com/"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  ONBOARDING
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
        <a
          style={{
            color: "white",
            opacity: "0.8",
            position: "absolute",
            bottom: "0",
            padding: "2px 10px",
            right: "0",
            fontSize: "10px",
          }}
          target="_blank"
          rel="noopener"
          href="https://www.freepik.com/"
        >
          Designed by Freepik
        </a>
      </div>
    </header>
  );
};
